import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { PageRequestInstanceDTO } from 'src/app/parametrage/core/model/page-request-instance-dto';
import { PageRequest } from 'src/app/parametrage/core/model/page-request';
import { PageCorrectionHistory } from 'src/app/mon-portefeuille/core/model/page-correction-history';
import { CreateDossierProfessionnel } from '../model/professionnel/create-dossier-professionnel';
import { PageDemandeResurmeDTO } from 'src/app/parametrage/core/model/page-demande-resurme-dto';
import { PageCorrectionsHistory } from 'src/app/parametrage/core/model/PageCorrectionHistoryDTO';
import { PageRequestDTO } from 'src/app/core/services/business/model/page-request-dto';

@Injectable({
    providedIn: 'root'
  })
  export class ProfessionnelService{

    constructor(private _restClientService : RestClientService) 
    {}

    
    findAllDossierEncours(filter,page,size) 
    {
        return this._restClientService.load<PageRequestInstanceDTO>('professionnel/find-all-dossier-encours'
        +'?filter='+filter
        +'&page='+page
        +'&size='+size
        );
    }
    
    findAllDossierAbandonne(filter,page,size) 
    {
        return this._restClientService.load<PageRequestInstanceDTO>('professionnel/find-all-dossier-abandonne'
        +'?filter='+filter
        +'&page='+page
        +'&size='+size
        );
    }
    
    findAllDossierCloture(filter,state,page,size) 
    {
        return this._restClientService.load<PageRequest>('professionnel/find-all-dossier-cloture'
        +'?filter='+filter
        +'&state='+state
        +'&page='+page
        +'&size='+size
        );
    }
        
    findAllDossier(filter,state:String[],debut, fin, page, size, sortColumn, direction) 
    {
        return this._restClientService.load<PageRequestDTO>('professionnel/find-all-dossier'
        +'?filter='+filter
        +'&state='+state
        +'&debut='+debut
        +'&fin='+fin
        +'&page='+page
        +'&size='+size
        +'&sortColumn='+sortColumn
        +'&direction='+direction
        );
    }
    
    findAllDossierAcorriger(filter, page, size, sortColomun, descending) 
    {
        return this._restClientService.load<PageCorrectionHistory>('professionnel/find-all-dossier-a-corriger'
        +'?filter='+filter
        +'&page='+page
        +'&size='+size
        +'&sortColomun='+sortColomun
        +'&descending='+descending
        );
    }


    findAllDossierClotureCardView(filter, state, page, size) {
        return this._restClientService.load<PageDemandeResurmeDTO>(
          "professionnel/find-all-dossier-cloture-card-view" +
            "?filter=" +
            filter +
            "&state=" +
            state +
            "&page=" +
            page +
            "&size=" +
            size
        );
    }


    findAllDossierAcorrigerCardView(filter, page, size, sortColomun, descending) {
        return this._restClientService.load<PageCorrectionsHistory>(
          "professionnel/find-all-dossier-a-corriger-card-view" +
            "?filter=" +
            filter +
            "&page=" +
            page +
            "&size=" +
            size +
            "&sortColomun=" +
            sortColomun +
            "&descending=" +
            descending
        );
    }
    
    
    createDossier(createDossierProfessionnel: CreateDossierProfessionnel)
    {
        return  this._restClientService.save<void>('professionnel/create-dossier', createDossierProfessionnel);
    }

    
  
}      

    